import React from 'react';

interface HeroHeaderProps {
  onAccessClick: () => void;
}

export const EarthquakeHeroHeader: React.FC<HeroHeaderProps> = ({ onAccessClick }) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-blue-600 via-blue-700 to-blue-900 text-white py-12 sm:py-16 md:py-20 px-4 sm:px-6 lg:px-8 flex items-center justify-center flex-1">
      {/* Decorative background glow accents */}
      <div className="absolute top-0 right-10 w-80 sm:w-96 h-80 sm:h-96 bg-red-500/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-10 w-80 sm:w-96 h-80 sm:h-96 bg-cyan-400/20 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-4xl mx-auto text-center z-10">
        {/* Davivienda Red + Solidary Pill */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-600/25 border border-red-400/50 text-white text-xs sm:text-sm font-semibold mb-6 shadow-sm backdrop-blur-sm">
          <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-ping" />
          Programa Solidario de Alivio y Reactivación de Vivienda
        </div>

        {/* Main Title */}
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-6 leading-tight">
          Más opciones para <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-200 via-rose-100 to-amber-100">empezar de nuevo</span>
        </h1>

        {/* Concise & Direct Narrative */}
        <p className="max-w-2xl mx-auto text-base sm:text-lg text-blue-50 leading-relaxed mb-8 font-normal">
          Sabemos que frente a la eventualidad de un sismo o terremoto las viviendas pueden sufrir afectaciones. Disponemos de opciones de compra, crédito con comisión y créditos preferenciales del <strong className="text-white font-bold underline decoration-red-400 underline-offset-4">8% al 8% E.A.</strong> para damnificados e interesados en apartamentos, apartaestudios y casas en <strong className="text-white font-bold">Manizales, Pereira, Armenia y Cali</strong>.
        </p>

        {/* Essential Feature Pills */}
        <div className="flex flex-wrap items-center justify-center gap-2.5 sm:gap-3 mb-10">
          <span className="bg-blue-800/80 border border-blue-400/40 text-blue-100 px-3.5 py-1.5 rounded-xl text-xs sm:text-sm font-medium shadow-sm">
            <span className="text-red-400 font-bold mr-1.5">●</span> Tasa Especial 8% al 8% E.A.
          </span>
          <span className="bg-blue-800/80 border border-blue-400/40 text-blue-100 px-3.5 py-1.5 rounded-xl text-xs sm:text-sm font-medium shadow-sm">
            <span className="text-red-400 font-bold mr-1.5">●</span> Apartamentos, Apartaestudios y Casas
          </span>
          <span className="bg-blue-800/80 border border-blue-400/40 text-blue-100 px-3.5 py-1.5 rounded-xl text-xs sm:text-sm font-medium shadow-sm">
            <span className="text-red-400 font-bold mr-1.5">●</span> Manizales, Pereira, Armenia y Cali
          </span>
        </div>

        {/* Primary CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            id="access-app-btn"
            onClick={onAccessClick}
            className="w-full sm:w-auto inline-flex items-center justify-center px-9 py-4 text-base sm:text-lg font-bold rounded-2xl text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 shadow-xl shadow-red-950/40 transform active:scale-95 transition-all duration-150 cursor-pointer"
          >
            Accede a nuestra aplicación
            <svg className="w-5 h-5 ml-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};
